import React from 'react';
import autobind from 'autobind-decorator';
import {Row} from 'react-bootstrap';
import {Glyphicon} from "./GlyphIcon";

export class MutableList extends React.Component {
    @autobind
    getData() {
        if(this.props.Data) {
            if(this.props.GetSortKey && this.props.GetSortKey()) {
                let key = this.props.GetSortKey();
                return this.props.Data.sort((a, b) => {
                    return a[key] - b[key];
                });
            }

            return this.props.Data;
        }

        return null;
    }

    render() {
        return (
            <div>
                { this.props.children }
                {
                    this.getData() ?
                        this.getData().map((x) =>
                            <Row key={this.props.GetItemKey(x)} className="pop-row">
                                <div className="pop-col">
                                    <this.props.Type
                                        Key={this.props.GetItemKey(x)}
                                        Item={x}
                                        UpdateItem={(value) => this.props.UpdateItem(this.props.GetItemKey(x), value)}
                                        {...this.props.AdditionalTypeProps}
                                    />
                                </div>
                                {
                                    this.props.Editable ?
                                        <div className="remove-table pop-remove">
                                            <a className="pndlm-remove-control" onClick={() => this.props.RemoveItem(this.props.GetItemKey(x))}>
                                                <Glyphicon glyph="remove-sign" />
                                            </a>
                                        </div> :
                                        null
                                }
                            </Row>
                        ) :
                        null
                }
                {
                    this.props.Editable ?
                        <Row className="pop-row">
                            <div className="float-right add-table pop-add">
                                <a className="pndlm-remove-control" onClick={() => this.props.AddItem()}>
                                    <Glyphicon glyph="plus-sign" />
                                </a>
                            </div>
                        </Row> :
                        null
                }
            </div>
        );
    }
}

